module.exports = __webpack_public_path__ + "morumbi-distribuidora.jpg?2de31533f6ffc9a0f2020b51cc49b239";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/morumbi-distribuidora.jpg
// module id = 140
// module chunks = 0